import { cn } from "@/utils/common.utils";
import {
  Paper,
  PaperProps,
  TableBodyProps,
  TableContainerProps,
  TableHeadProps,
  TableProps,
} from "@mui/material";
import { ReactNode, Suspense } from "react";
import AppLoadingDataTable from "./AppLoadingDataTable";
import AppTable from "./AppTable";
import AppTableBody from "./AppTableBody";
import AppTableContainer from "./AppTableContainer";
import AppTableHead from "./AppTableHead";
import AppTableLayoutSkeleton from "./AppTableLayoutSkeleton";

const AppTableLayout = ({
  children,
  header,
  tableProps: { stickyHeader, ...otherTableProps } = { stickyHeader: true },
  tableHeadProps,
  tableBodyProps,
  paperProps,
  keySuspense,
  tableContainerProps = {},
}: AppTableLayoutProps) => {
  return (
    <>
      <Suspense
        fallback={
          <AppTableLayoutSkeleton header={header}>
            <AppLoadingDataTable />
          </AppTableLayoutSkeleton>
        }
        key={keySuspense}
      >
        <Paper
          sx={{
            height: "calc(100% - 34px)",
            overflow: "auto",
            boxShadow: "unset",
            position: "relative",
            backgroundColor: "transparent",
            ...paperProps?.sx,
          }}
          {...paperProps}
        >
          <AppTableContainer
            sx={{
              overflow: "auto",
              height: "100%",
            }}
          >
            <AppTable
              {...otherTableProps}
              sx={{
                borderLeft: "1px solid #eee",
                borderRight: "1px solid #eee",
                ...otherTableProps?.sx,
              }}
            >
              <AppTableHead
                {...tableHeadProps}
                className={cn(tableHeadProps?.className, {
                  "sticky z-10 top-0": stickyHeader,
                })}
              >
                {header}
              </AppTableHead>
              <AppTableBody
                {...tableBodyProps}
                sx={{
                  backgroundColor: "common.white",
                  ...tableBodyProps?.sx,
                }}
              >
                {children}
              </AppTableBody>
            </AppTable>
          </AppTableContainer>
        </Paper>
      </Suspense>
    </>
  );
};

export type AppTableLayoutProps = {
  header?: ReactNode;
  children: ReactNode;
  tableProps?: TableProps;
  tableContainerProps?: TableContainerProps;
  // boxContainerProps?: BoxProps;
  skeletonGrid?: ReactNode;
  tableHeadProps?: TableHeadProps;
  tableBodyProps?: TableBodyProps;
  paperProps?: PaperProps;
  keySuspense?: string;
};

export default AppTableLayout;
